import bem from 'utils/bem';

export const block = bem('global-style-modal');
